import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
// Global on purpose. This used to be imported by Layout, which is lazy and only
// ever mounts behind AuthGate — so the screens a signed-out user actually sees
// (unauthorized, 404) loaded with no stylesheet at all.
import './App.scss';
import {BrowserRouter} from 'react-router-dom';
import {AppProvider} from './context/app-context';
import {BreadcrumbsProvider} from './context/breadcrumbs-context';
import {SnackbarProvider} from 'notistack'
import {I18nextProvider} from "react-i18next";
import i18n from "./i18n.ts";
import {QueryClientProvider} from '@tanstack/react-query';
import {createQueryClient} from './lib/query-client.ts';

// One client for the app's lifetime. Created outside the component so a
// StrictMode double-render cannot hand the tree two different caches.
const queryClient = createQueryClient();


ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <I18nextProvider i18n={i18n}>
            <QueryClientProvider client={queryClient}>
            <BrowserRouter>
                <SnackbarProvider>
                    <AppProvider>
                        <BreadcrumbsProvider>
                            <App/>
                        </BreadcrumbsProvider>
                    </AppProvider>
                </SnackbarProvider>
            </BrowserRouter>
            </QueryClientProvider>
        </I18nextProvider>
    </React.StrictMode>
);
